"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AZURE_MONITOR_STATSBEAT_FEATURES = exports.DEFAULT_ROLE_NAME = exports.APPLICATION_INSIGHTS_OPENTELEMETRY_VERSION = void 0;
exports.APPLICATION_INSIGHTS_OPENTELEMETRY_VERSION = "3.14.0";
exports.DEFAULT_ROLE_NAME = "Web";
exports.AZURE_MONITOR_STATSBEAT_FEATURES = "AZURE_MONITOR_STATSBEAT_FEATURES";
//# sourceMappingURL=types.js.map